import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IDeletePropertyPayload extends ISagaCb {
    propertyId: string
}

export interface IDeletePropertyState {
    status: string
    data: any
    errors: any
}

const initialState: IDeletePropertyState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteProperty = createSlice({
    name: 'property/delete',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeletePropertyPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deletePropertyActions = deleteProperty.actions
export default deleteProperty.reducer
